module.exports = __webpack_public_path__ + "img/yongan.f0cf3ea0.png";